import { Store } from "@/utils/store";
export default {
    inserted(el, binding) {
        const { value, modifiers } = binding;
        let permissionData = Store.permissionData;
        let find = permissionData.find(
            (el) => el.permissionCode === value
        );
        if (!find?.isCheck) {
            if (modifiers?.hidden) {
                el.style.display = 'none';
            } else {
                el.classList.add('disabled-check');
                el.style.pointerEvents = 'none';
                el.style.cursor = 'not-allowed';
                const children = el.getElementsByTagName('*');
                for (let child of children) {
                    child.style.pointerEvents = 'none';
                }
                el.setAttribute('data-permission-disabled', 'true');
            }
        } else {
            el.style.display = '';
            el.classList.remove('disabled-check');
            el.disabled = false;
            el.removeAttribute('aria-disabled');
            el.style.pointerEvents = '';
            el.style.opacity = '';
            el.style.cursor = '';
            el.removeAttribute('data-permission-disabled');
        }
    }
}